
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkDebtorInvoiceTypeEnum } from '../models/work-debtor-invoice-type-enum';

export function getCreateDebtorDtoFormGroup() {
return new FormGroup({
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    number: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    qrNumber: new FormControl<number | undefined>(undefined),
    invoicing: new FormControl<string | undefined>('', [Validators.required]),
    amountIncl: new FormControl<number | undefined>(undefined, [Validators.required]),
    maturity: new FormControl<string | undefined>('', [Validators.required]),
    partial: new FormControl<number | undefined>(undefined, [Validators.required]),
    invoiceType: new FormControl<WorkDebtorInvoiceTypeEnum | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    billingSalutation: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    billingCompany: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingFirstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingLastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingStreet: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingAddressAdditional: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingZipcode: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    billingCity: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    billingCanton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    billingCountry: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
})
;
}
      